import axios from 'axios';
import { getNonGwApiRoot } from '../../../constants/ParamountReactConstants';
import { ExpiNewContent } from '../../../../types/extendedInfo';

export function updateExtendedInfo(
  extended_informations: { item_id: number; types: { id: number; contents: ExpiNewContent[] }[] }[]
) {
  return {
    type: 'UPDATE_EXTENDED_INFORMATION',
    payload: axios.patch(`${getNonGwApiRoot()}/items/extended_informations`, {
      extended_informations,
    }),
  };
}
